// Canonical prices remain CAD. Convert display text only, including dynamic views.
(()=>{
 const read=(key)=>{try{return localStorage.getItem(key)}catch{return null}};
 const write=(key,value)=>{try{localStorage.setItem(key,value)}catch{}};
 let preference=read('linx-currency');
 let currency=['CAD','USD'].includes(preference)?preference:'CAD';
 let rate=null;
 const originals=new WeakMap();
 const control=document.createElement('div');control.className='store-currency';
 control.innerHTML='<label for="store-currency">Currency</label><select id="store-currency" aria-label="Display currency"><option value="CAD">CAD $</option><option value="USD">USD $</option></select><span class="currency-status" role="status"></span>';
 const header=document.querySelector('#HeaderWrapper');header.before(control);
 const select=control.querySelector('select'),status=control.querySelector('.currency-status');
 const pattern=/\$\s*([\d,]+(?:\.\d{1,2})?)(?:\s*(?:CAD|USD))?/g;
 function render(){
  observer.disconnect();
  select.value=currency;
  const active=currency==='USD'&&rate?'USD':'CAD';
  status.textContent=currency==='USD'&&!rate?'USD rate unavailable; prices shown in CAD.':'';
  const walker=document.createTreeWalker(document.body,NodeFilter.SHOW_TEXT);
  while(walker.nextNode()){
   const node=walker.currentNode;if(node.parentElement.closest('script,style,select,textarea,.store-currency'))continue;
   let record=originals.get(node);
   if(!record||node.nodeValue!==record.output)record={base:node.nodeValue};
   if(!record.base.includes('$'))continue;
   record.output=record.base.replace(pattern,(_,amount)=>new Intl.NumberFormat('en-CA',{style:'currency',currency:active,currencyDisplay:'code'}).format(Number(amount.replaceAll(',',''))*(active==='USD'?rate:1)));
   node.nodeValue=record.output;originals.set(node,record);
  }
  observer.observe(document.body,{childList:true,subtree:true,characterData:true});
 }
 const observer=new MutationObserver(render);
 select.onchange=()=>{currency=select.value;preference=currency;write('linx-currency',currency);render()};
 render();
 async function json(url){const r=await fetch(url,{signal:AbortSignal.timeout(5000)});if(!r.ok)throw Error('Unavailable');return r.json()}
 async function rates(){
  try{const data=await json(window.linxAsset("currency-rate.json"));if(data.base==='CAD'&&data.rates.USD>0)rate=data.rates.USD}catch{}
  render();
  try{const data=await json('https://api.frankfurter.dev/v1/latest?base=CAD&symbols=USD');if(data.base==='CAD'&&data.rates.USD>0){rate=data.rates.USD;render()}}catch{}
 }
 rates();
 if(!preference){
  json('https://ipapi.co/json/').then(data=>{if(!preference){currency=data.country_code==='US'?'USD':'CAD';render()}}).catch(()=>{});
 }
})();
